import Schedule from 'modules/schedule'

export function SchedulePage() {
	return <Schedule />
}
